/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import "./MainLayout.css";
import { useLocation } from "react-router-dom";
import { GoHome } from "react-icons/go";
import { MdOutlineFolderCopy } from "react-icons/md";
import { AiOutlineTags } from "react-icons/ai";
import { LuUsers, LuPiggyBank } from "react-icons/lu";
import { IoImagesOutline } from "react-icons/io5";
import { IoLogOutOutline } from "react-icons/io5";
// import { PiAirplaneTilt } from "react-icons/pi";
// import { RiSuitcaseLine } from "react-icons/ri";
import * as Menubar from "@radix-ui/react-menubar";
import { useNavigate } from "react-router-dom";
// import * as Form from "@radix-ui/react-form";

const menulinks = [
  { name: "Dashboard", url: "/home", icon: <GoHome size="1.5rem" /> },
  {
    name: "Campaigns",
    url: "/campaigns",
    icon: <MdOutlineFolderCopy size="1.5rem" />,
  },
  {
    name: "Categories",
    url: "/categories",
    icon: <AiOutlineTags size="1.5rem" />,
  },
  { name: "User", url: "/user", icon: <LuUsers size="1.5rem" /> },
  {
    name: "Sources",
    url: "/sources",
    icon: <IoImagesOutline size="1.5rem" />,
  },
  {
    name: "Pledges",
    url: "/pledges",
    icon: <LuPiggyBank size="1.5rem" />,
  },
  // {
  //   name: "Communities",
  //   url: "/communities",
  //   icon: <PiAirplaneTilt size="1.5rem" />,
  // },
  // {
  //   name: "Business",
  //   url: "/business",
  //   icon: <RiSuitcaseLine size="1.5rem" />,
  // },
];

const MainLayout = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const parseJwt = (token) => {
    try {
      return JSON.parse(atob(token.split(".")[1]));
    } catch (e) {
      return null;
    }
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    navigate("/");
  };

  useEffect(() => {
    let token = localStorage.getItem("token");
    if (!token) {
      navigate("/");
      return;
    }
    const decodedJwt = parseJwt(token);
    if (decodedJwt.exp * 1000 < Date.now()) {
      // Token is expired, redirect to login
      navigate("/");
    }
  }, [navigate, location]);

  return (
    <div className="layout">
      <div className="sideBar">
        <div className="menu">
          <div className="logoSection">
            <img 
              src="/logo_rafl.png" 
              alt="Rafl Logo" 
              className="raflLogo"
            />
          </div>
          <Menubar.Root>
            <Menubar.Menu className="menuBar">
              {menulinks.map((data, i) => (
                <div
                  className={location.pathname === data.url ? "actLink" : ""}
                  key={i}
                  onClick={() => navigate(data.url)}
                >
                  <Menubar.Trigger className="menuLinks">
                    <div className="menuIcons">{data.icon}</div>
                    <div className="menuName">{data.name}</div>
                  </Menubar.Trigger>
                </div>
              ))}
            </Menubar.Menu>
          </Menubar.Root>
          <div className="logoutSection">
            <div className="menuLinks logoutButton" onClick={handleLogout}>
              <div className="menuIcons">
                <IoLogOutOutline size="1.5rem" />
              </div>
              <div className="menuName">Logout</div>
            </div>
          </div>
        </div>
      </div>
      <div className="appContent">{children}</div>
    </div>
  );
};

export default MainLayout;
